import { defineStyleConfig } from '@chakra-ui/react';

export const Link = defineStyleConfig({
  baseStyle: {
    _hover: {
      textDecoration: 'none',
    },
    _activeLink: {
      color: 'primary.500',
    },
  },
});
